import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Base from './Base';
import React from 'react';
import Indian from './Indian';
import Test from './Test';
import Home from './Home';

const App: React.FC = () => (
	<BrowserRouter>
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/indian" element={<Indian />} />
			<Route path="/orpheus" element={<Base agentId='-OC4RV-orpheus-companion'
					description='Chat with an AI Companion that can <laugh>, <sigh>, <cough>, <groan>, <gasp>, and responds in real time.'
					header={<span>Experience <b style={{color: 'var(--primary-colors--primary-1)'}}>Emotional, Human-Like</b> Voice AI<br /> with ultra‑low latency</span>} />} />
			<Route path="/benchmark" element={<Test />} />
		</Routes>
	</BrowserRouter>
);

export default App;